<app-document-subheader></app-document-subheader>
<div class="page-container">
  <div class="card card-light w-100">
    <div class="card-body">
      <div class="container-fluid">
        <app-application-fee-rule-form-content />
        <app-application-fee-rule-tabs-details />
      </div>
    </div>
  </div>
</div>
